<script lang="ts">
  import { formatAgo, formatDuration, meetingParticipants, type RadarMeeting } from "../model";
  import AvatarCluster from "./AvatarCluster.svelte";

  let { meeting, now, expanded = false, onToggle }: { meeting: RadarMeeting; now: Date; expanded?: boolean; onToggle?: () => void } = $props();
  let duration = $derived(formatDuration(meeting.startedAt, meeting.endedAt ?? now));
  let ago = $derived(meeting.endedAt ? formatAgo(meeting.endedAt, now) : null);
  let detailsId = $derived(`meeting-${meeting.id}-details`);
  let people = $derived(meetingParticipants(meeting));
</script>

<div class:expanded class:ended={meeting.status === "ended"} class="session-row">
  <div class="session-summary">
    <span class:active={meeting.status !== "ended"} class="status-dot"><span></span></span>
    <div class="session-copy">
      <button class="session-toggle" type="button" aria-expanded={expanded} aria-controls={detailsId} onclick={() => onToggle?.()}>
        <strong title={meeting.room}>{meeting.room}</strong>
      </button>
      <AvatarCluster {people} id={`meeting-${meeting.id}`} maxVisible={4} muted={meeting.status === "ended"} label={`${meeting.room} participants`} />
    </div>
    <span class="session-time"><span>{duration}</span>{#if ago}<small>{ago}</small>{/if}</span>
  </div>
  {#if expanded}
    <span class="session-details" id={detailsId}>
      <span>Started</span><span>{meeting.startedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
      {#if meeting.endedAt}<span>Ended</span><span>{meeting.endedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>{/if}
      <span>People</span><span>{meeting.participants.length}</span>
      <span>Duration</span><span>{duration}</span>
    </span>
  {/if}
</div>
